import i18n from "i18n";
export const WORKFLOW_DEFINITIONS_QUERY_KEY = ["aiagent", "workflow-definitions"];
export const TOKEN_USAGE_QUERY_KEY = ["aiagent", "workflow-runs", "token-usage"];
export const DEFAULT_LAYOUT = {
  entityTableId: "agent-workflows",
  defaultPageSize: 20,
  defaultSort: { attributeId: "title", direction: "asc" },
  defaultDisplayedAttributes: ["title", "description", "disabled", "provider", "model", "scheduling"],
  defaultColumnOrder: ["title", "description", "disabled", "provider", "model", "scheduling"]
};
export const ADDITIONAL_ATTRIBUTES = [
  {
    id: "scheduling",
    get title() {
      return i18n.t("agent_workflows_constants.scheduling", { ns: "enterprise_ai" });
    },
    sortable: false
  }
];
export const ATTRIBUTES = [
  {
    id: "title",
    get title() {
      return i18n.t("agent_workflow_details.title", { ns: "enterprise_ai" });
    },
    type: "STRING",
    sortable: true,
    searchable: true
  },
  {
    id: "description",
    get title() {
      return i18n.t("agent_workflow_details.description", { ns: "enterprise_ai" });
    },
    type: "STRING",
    sortable: true,
    searchable: true
  },
  {
    id: "disabled",
    get title() {
      return i18n.t("agent_workflow_details.status", { ns: "enterprise_ai" });
    },
    type: "BOOLEAN",
    sortable: true,
    filterable: true,
    filter_options: [
      {
        value: "true",
        get title() {
          return i18n.t("workflow_status.status_disabled", { ns: "enterprise_ai" });
        }
      },
      {
        value: "false",
        get title() {
          return i18n.t("workflow_status.status_enabled", { ns: "enterprise_ai" });
        }
      }
    ]
  },
  {
    id: "provider",
    get title() {
      return i18n.t("agent_workflow_details.provider", { ns: "enterprise_ai" });
    },
    type: "STRING",
    filterable: true
  },
  {
    id: "model",
    get title() {
      return i18n.t("agent_workflow_details.model", { ns: "enterprise_ai" });
    },
    type: "STRING",
    sortable: true,
    filterable: true,
    filter_options: [
      { value: "gpt-4.1", title: "GPT-4.1" },
      { value: "gpt-4.1-mini", title: "GPT-4.1 Mini" }
    ]
  }
];
const keywordRange = (keyword) => ({
  type: "keyword",
  keyword
});
export const tokenUsageRanges = [
  { range: keywordRange("Today"), label: "token_usage_ranges.today" },
  { range: keywordRange("Monday current week to today"), label: "token_usage_ranges.this_week" },
  { range: keywordRange("1st of current month to today"), label: "token_usage_ranges.this_month" }
];
